import { Injectable } from "@angular/core";
import * as _ from "lodash";

@Injectable({
    providedIn: "root"
})

export class FormatsUtil {

    constructor() { }
    
    getNDCFormat(drugNdc, IsformatNeeded: boolean = true) {
        if(IsformatNeeded && drugNdc)
        {
            if(drugNdc?.length  == 11 || drugNdc?.length  == 10) {
                return drugNdc ? (drugNdc.substr(0, 5)) + "-" + (drugNdc.substr(5, 4)) + "-" + (drugNdc.substr(9, 11)) : null;
            } else if (drugNdc.length  <= 5) {
                return  drugNdc.substr(0, 5) + "-  -";
            }  else if(drugNdc.length  > 5 && drugNdc.length  <= 9) {
                return   (drugNdc.substr(0, 5)) + "-" + (drugNdc.substr(5, 4)) + "-"; 
            } 
        }
        else 
            return  drugNdc ? drugNdc : null;
     }
     getPhoneFormat(number) {
         if (number) {
         return ( ((number && number[0] === '(') ?  "" : "(") + (number.substr(0, 3)) +  ((number && number[4] === ')') ?  "" : ")") + (number.substr(3, 3)) + "-" + (number.substr(6, 4)));
         } else {
             return "";
         }
     }
     getPhoneFormatForWrongFax(number) {
         if (number) {
         return ( ((number && number[0] === '(') ?  "" : "(") + (number.substr(0, 3)) +  ((number && number[4] === ')') ?  "" : ")") + (number.substr(3, 3)) + "-" + (number.substr(6, 5)));
         } else {
             return "";
         }
     }
     checkRefill(rx: string, aref: number, ref: number) {
        if (ref !== 0) {
            return rx + " - R";
        } else {
            return rx;
        }
    }
    
    getDeaFormat(dea) {
        return  (dea && dea.length > 10 && !dea.includes("-")) ? (dea.substr(0, 9)) + "-" + (dea.substr(9, 5)) : dea;
    }

    twoFixed(value) {
         return value ? value.toFixed(2) : "0.00";
    }
    
    threeFixed(value) {
        return value ? value.toFixed(3) : "0.000";
    }
    displaytallmanlettering(drugInfo, applyUppercase?, addUnit?) {
        if(drugInfo?.tallmanDrugName) {
            return (drugInfo?.tallmanDrugName) + " " + (drugInfo?.strength ? drugInfo?.strength?.toUpperCase() : "") + (addUnit ? " " +(drugInfo?.drugunit ? drugInfo?.drugunit : ''):"")+ " " + (drugInfo?.drugformname ? drugInfo?.drugformname?.toUpperCase() : "")
        } else {
            return (applyUppercase ? (drugInfo?.drugname?.toUpperCase()) : drugInfo?.drugname)+ " " + (drugInfo?.strength?.trim() ? (applyUppercase ? drugInfo?.strength.trim().toUpperCase() : drugInfo?.strength.trim()) : "") +(addUnit ? " " + (drugInfo?.drugunit ? (applyUppercase ? drugInfo?.drugunit.toUpperCase() : drugInfo?.drugunit) : ''):"") + " " + (drugInfo?.drugformname ? (applyUppercase ? (drugInfo?.drugformname?.toUpperCase()) : drugInfo?.drugformname):"");
        }
    }

    mergeOrAddIntoArray(array1: any[], array2: any[], key: string) {
        const merged = _.values(_.merge(_.keyBy(array1, key), _.keyBy(array2, key)));
        return merged;
    }
}